/**
 * The comments feature's data entry point, for another feature's adapter: the
 * thread's query options and the seed a post read uses. It loads the query
 * client and the HTTP client but no UI, so an adapter that only hands a post's
 * embedded comments over does not pull the comment screens in behind it.
 * Only another feature's `api/` layer imports it; UI and hooks use the main
 * entry.
 */
export { getCommentsV2QueryOptions, seedPostComments } from './queryOptions';
